import { cpf, cnpj } from 'cpf-cnpj-validator'

export const cpfValidator = (value: string): boolean => {
  const CPF_SIZE = 11
  if (value?.length === CPF_SIZE) {
    return cpf.isValid(value)
  }
  return false
}

export const cnpjValidator = (value: string): boolean => {
  const CNPJ_SIZE = 14
  if (value?.length === CNPJ_SIZE) {
    return cnpj.isValid(value)
  }
  return false
}

export const mobileValidator = (value: string): boolean => {
  if (!value) {
    return false
  }
  const regExp = /^(\(?\d{2}\)?[\s|-]?)(9\d{4}-?\d{4})$/
  return regExp.test(value)
}

export const phoneValidator = (value: string): boolean => {
  if (!value) {
    return false
  }
  const regExp = /^(\(?\d{2}\)?[\s|-]?)(\d{4}-?\d{4})$/
  return regExp.test(value)
}
